// extracted by mini-css-extract-plugin
export default {"container":"cstYh7","label":"y3bQDt","input":"X2MjW9","large-input":"xCOVLV","largeInput":"xCOVLV","icon":"k_0agC","iconSmall":"mggcJ9"};